import {
  Box,
  HStack,
  Spacer,
  chakra,
  Icon,
  Flex,
  Image,
  Badge,
  Tooltip,
  Text,
  Link,
  useDisclosure,
} from "@chakra-ui/react";
import React from "react";
import { FiShare2 } from "react-icons/fi";
import { Link as ReachLink } from "react-router-dom";
import StarRatings from "react-star-ratings";
import ShareProfileModal from "../../../utils/ShareProfileModal";
function PoliticianCard(props: Ipoliticians) {
  const { isOpen, onOpen, onClose } = useDisclosure();

  return (
    <>
      <Box
        bg="whitesmoke"
        maxW="250px"
        padding="0"
        marginInline="5px"
        marginBlock="10px"
        rounded="lg"
        height="fit-content"
        shadow="lg"
      >
        <Image
          src={props.image}
          alt={props.name}
          roundedTop="lg"
          maxHeight="250px"
          width="250px"
          height="230px"
          fit="cover"
        />

        <Box padding="2" maxW="fit-content" rounded="lg">
          <HStack>
            {/* {data.isNew && ( */}
            <Badge rounded="full" px="2" fontSize="0.8em" colorScheme="red">
              {props.country}
            </Badge>
            <Badge
              rounded="full"
              px="2"
              fontSize="0.8em"
              textColor="white"
              background="dodgerblue"
            >
              {props.politicalParty}
            </Badge>
            <Spacer />
            <Tooltip
              label="Share"
              bg="white"
              placement={"top"}
              color={"gray.800"}
              fontSize={"1em"}
            >
              <chakra.button
                onClick={onOpen}
                display={"flex"}
                id={"SharePolitician" + props._id}
              >
                <Icon as={FiShare2} alignSelf={"center"} />
              </chakra.button>
            </Tooltip>
            <ShareProfileModal
              url={window.location.hostname + "/politician-view/" + props._id}
              name={"Politician"}
              image={props.image}
              isOpen={isOpen}
              onClose={onClose}
            />
          </HStack>
          <Flex mt="1" justifyContent="space-between" alignContent="center">
            <Text
              fontSize="larger"
              fontWeight="semibold"
              as="p"
              textAlign="center"
            >
              {props.name}
            </Text>
          </Flex>
          <Flex justifyContent="space-between" alignContent="center">
            <Text as="p" fontSize="0.8em" textAlign="left">
              {props.details?.substring(0, 100)}...
            </Text>
            {/* <Rating rating={data.rating} numReviews={data.numReviews} /> */}
          </Flex>
          <Flex justifyContent="space-between" alignContent="center">
            <StarRatings
              starDimension="18px"
              style={{
                margin: "0",
                padding: "0",
              }}
              starSpacing="0px"
              starRatedColor="#D10024"
              numberOfStars={5}
              name="rating"
              rating={props.rating}
            />{" "}
            <Text>{props.reviewCount} Reviews</Text>
          </Flex>
          <Flex
            alignContent="center"
            width="fit-content"
            margin="auto"
            marginTop="5"
          >
            <Link
              color="white"
              background="#D10024"
              outline="#D10024"
              border="1px"
              borderRadius="5px"
              fontSize="md"
              className="btn"
              _hover={{ bg: "white", color: "#D10024", outline: "#D10024" }}
              colorScheme="blue"
              as={ReachLink}
              id={"PoliticianDetail" + props._id}
              to={"/politician-view/" + props._id}
              _focus={{
                boxShadow: "none",
                textDecor: "none",
              }}
            >
              {"Read More"}
            </Link>
          </Flex>
        </Box>
      </Box>
    </>
  );
}
export default PoliticianCard;
